export const getSettingApiErrorKey = (error: any): string | undefined => {
  const data = error?.response?.data || error?.data
  const message = data?.message

  if (Array.isArray(message)) return message[0]
  return typeof message === 'string' ? message : undefined
}

export const createSettingErrorState = <T extends Record<string, string>>(
  initialState: T,
  error: any,
  translate: (key: string) => string,
  namespace: string,
  fallbackKey: keyof T
): T => {
  const errorKey = getSettingApiErrorKey(error)
  const fieldKey = errorKey && Object.prototype.hasOwnProperty.call(initialState, errorKey)
    ? errorKey
    : fallbackKey

  return {
    ...initialState,
    [fieldKey]: translate(errorKey ? `${namespace}.MESSAGE.${errorKey}` : `${namespace}.MESSAGE.ERROR`)
  }
}
